import React from "react";
import { Box, Grid, Typography } from "@mui/material";
import useWindowSize from "../hooks/windowSize"; // Adjust the path as necessary
import image from '../../assets/images/1.jpg'

// Sample image data with placeholder images
const gridAreas = [
  "a",
  "b",
  "c",
  "d",
  "e",
  "f",
  "g",
  "h",
  "i",
  "j",
  "k",
  "l",
  "m",
  "n",
  "o",
];
const images = [
  {
    url: require("../../assets/images/1.jpg"),
    title: "Image 1",
    description: "Description 1",
  },
  {
    url: require("../../assets/images/2.jpg"),
    title: "Image 2",
    description: "Description 2",
  },
  {
    url: require("../../assets/images/3.jpg"),
    title: "Image 3",
    description: "Description 3",
  },
  {
    url: require("../../assets/images/4.jpg"),
    title: "Image 4",
    description: "Description 4",
  },
  {
    url: require("../../assets/images/5.jpg"),
    title: "Image 5",
    description: "Description 5",
  },
  {
    url: require("../../assets/images/6.jpg"),
    title: "Image 6",
    description: "Description 6",
  },
  {
    url: require("../../assets/images/7.jpg"),
    title: "Image 1",
    description: "Description 1",
  },
  {
    url: require("../../assets/images/8.jpg"),
    title: "Image 1",
    description: "Description 1",
  },
  {
    url: require("../../assets/images/9.jpg"),
    title: "Image 1",
    description: "Description 1",
  },
  {
    url: require("../../assets/images/10.jpg"),
    title: "Image 1",
    description: "Description 1",
  },
  {
    url: require("../../assets/images/1.jpg"),
    title: "Image 1",
    description: "Description 1",
  },
  {
    url: require("../../assets/images/2.jpg"),
    title: "Image 1",
    description: "Description 1",
  },
  {
    url: require("../../assets/images/3.jpg"),
    title: "Image 1",
    description: "Description 1",
  },
  {
    url: require("../../assets/images/4.jpg"),
    title: "Image 1",
    description: "Description 1",
  },
  {
    url: require("../../assets/images/5.jpg"),
    title: "Image 1",
    description: "Description 1",
  },
];

const GalleryGrid = ({ displayedImages = images }) => {
  const { width, height } = useWindowSize();

  let limit;

  // Set limit based on screen size
  if (width < 600) {
    limit = 8; // Limit for extra small screens
  } else if (width < 900) {
    limit = 15; // Limit for small screens
  } else if (width < 1200) {
    limit = 15; // Limit for medium screens
  } else {
    limit = 15; // Default limit for larger screens
  }

  // Limit the number of images displayed based on the screen size
  const propImages = displayedImages.slice(0, limit);
  return (
    <Box
      sx={{
        display: "grid",
        gap: 2,
        gridTemplateColumns: {
          xs: "repeat(2, 1fr)", // 2 columns on extra small screens
          sm: "repeat(3, 1fr)", // 3 columns on small screens
          md: "repeat(3, 1fr)", // 4 columns on medium screens
          // lg: "repeat(5, 1fr)", // 5 columns on large screens
        },
        gridTemplateRows: {
          xs: "repeat(7, 1fr)",
          sm: "repeat(5, 1fr)",
        },
        gridTemplateAreas: {
          xs: `
            "a b"
            "c c"
            "d d"
            "e f"
            "g g"
            "h i"
          
        `,
          sm: `
          "a b c"
          "d e c"
          "f g h"
          "i g j"
          "k l m"
          "k n o"
          
        `,
          md: `
          "a b c"
          "d e c"
          "f g h"
          "i g j"
          "k l m"
          "k n o"
          
        `,
        },
      }}
    >
      {propImages.map((img, index, array) => (
        <Box
          sx={{
            position: "relative",
            gridArea: gridAreas[index],
            overflow: "hidden",
            borderRadius: 2,
            boxShadow: "0 4px 8px rgba(0,0,0,0.2)",
            cursor: "pointer",
            transition: "transform 0.3s ease",
            width:'100%',
            height:{
              xs:'200px',
              sm: index === 2 || index === 6 || index === 10 ? '415px' : '200px',
              md: index === 2 || index === 6 || index === 10 ? '415px' : '200px',
            },
            "&:hover": {
              transform: "scale(1.02)",
            },
          }}
        >
          <Box
            component="img"
            src={img.url}
            alt={img.title}
            sx={{
              width: "100%",
              height: "100%",
              display: "block",
            objectFit:'cover',
            objectPosition:'center',
            }}
          />
          <Box
            className="overlay"
            sx={{
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              backgroundColor: "rgba(0, 0, 0, 0.6)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              opacity: 0,
              transition: "opacity 0.3s ease-in-out",
              "&:hover": {
                opacity: 1,
              },
              color: "#fff",
              textAlign: "center",
              padding: 2,
            }}
          >
            <Box>
              <Typography variant="h6" sx={{ fontWeight: "bold", mb: 1 }}>
                {img.title}
              </Typography>
              <Typography variant="body2">{img.description}</Typography>
            </Box>
          </Box>
        </Box>
      ))}
    </Box>
  );
};

export default GalleryGrid;
